import React from 'react'

import { Customers } from 'Features/pricing/components/Customers/Customers'
import { Faq } from 'Features/pricing/components/Faq/Faq'
import { PricingFooterStyled } from './PricingFooter.styled'

type PricingFooterProps = {
  bundle: boolean
}

export const PricingFooter = ({ bundle }: PricingFooterProps) => {
  return (
    <PricingFooterStyled>
      <Customers />
      <Faq bundle={bundle} />
    </PricingFooterStyled>
  )
}
